// extracted by mini-css-extract-plugin
export var label = "Summary-module--label--gTMeH";
export var text = "Summary-module--text--HQTPk";
export var title = "Summary-module--title--t9jxX";
export var total = "Summary-module--total--fX8QZ";
export var wrapper = "Summary-module--wrapper--E4chj";